import React from 'react';
import { Loading } from '@match/react-component-library';
import { useContactDetails } from 'modules/hooks';

const ContactUsEmailPage: React.FunctionComponent<{}> = () => {
  const { contactDetails, isLoading } = useContactDetails();

  return isLoading ? (
    <Loading />
  ) : (
    <iframe src={contactDetails.email.url} height={800} frameBorder="none" width={350} />
  );
};

export default ContactUsEmailPage;
